import React, { useState, useEffect } from "react";

import { config } from "../../config";
import { handleResponse } from "../../helpers/response";

import loader from "../../images/loader.svg";
import { useTranslation} from "react-i18next";

const FooterExportMenu = (props) => {
  const [footerMenu, setFooterMenu] = useState([]);
  const [showLoader, setShowLoader] = useState(true);
  const { t, i18n } = useTranslation();
  useEffect(() => {
    const menutype = props.menuName + i18n.language;
    const link =
      config.apiUrl +
      "api/import/joomla/topmenu/" +
      i18n.language +
      "?menutype=" +
      menutype;
    fetch(link, { method: "GET" })
      .then(handleResponse)
      .then((json) => {
        setFooterMenu(json);
        setShowLoader(false);
      })
      .catch((error) => {
        alert("error");
      });
    
  }, []);

 
  return (
    <>
    <h4>{props.title}</h4>
    <ul className="uk-list">
      <li
        className={
          showLoader ? "menu-loader uk-position-relative " : "uk-hidden"
        }
      >
        <div className="loader-overlay  uk-position-z-index">
          <div className="uk-position-center">
            <img
              className="loader-img"
              src={loader}
              uk-svg={""}
              alt={"loading..."}
            />
          </div>
        </div>
      </li>
      {showLoader === false && (
        footerMenu.joomla.map((itm, inx) => {
  
        return (
          itm!== undefined && itm.parentId === 1 && (
            <li key={inx}>
              <a
              
                href={"/"+itm.alias}
              >
                {itm.title}
              </a>
            
            </li>
          )
        );
      }))
    }
      
    </ul>
    </>
  );
};
export default FooterExportMenu;
